interface DividerProps {
    className?: string;
    y?: number;
}

export const Divider = ({ y = 1, className = '' }: DividerProps) => {
    return <div className={`tw-bg-accents-5 ${className}`} style={{ height: `${y}px`, margin: `${y * 4}px` }} />;
};

interface SpacerProps {
    className?: string;
    y?: number;
}

export const Spacer = ({ y = 1, className = '' }: SpacerProps) => {
    return <div className={`${className}`} style={{ margin: `${y * 4}px` }} />;
};
